// extracted by mini-css-extract-plugin
module.exports = {"image":"section-yellowblue-module--image--3VcLE"};